import { ChildId, JournalId, QualificationId } from 'types';

export const QUALIFICATIONS = (specialJournalId: JournalId) =>
    `api/v1/journals/${specialJournalId}/qualificationBases`;
export const QUALIFICATION = (specialJournalId: JournalId, qualificationBasisId: QualificationId) =>
    `api/v1/journals/${specialJournalId}/qualificationBases/${qualificationBasisId}`;

export const QUALIFICATION_CHILD = (specialJournalId: JournalId, childId: ChildId) =>
    `/api/v1/journals/${specialJournalId}/qualificationBases/children/${childId}`;
